import React from 'react';
import clsx from 'clsx';

interface TextAreaProps {
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const TextArea = ({
  name,
  value,
  onChange,
  placeholder,
  className,
  disabled = false,
}: TextAreaProps) => (
  <textarea
    name={name}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
    placeholder={placeholder}
    className={clsx(
      'text-neutral-700 placeholder:text-neutral-400',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'border border-neutral-300 rounded-md p-3',
      className,
    )}
    disabled={disabled}
  />
);
